import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { clearChanges } from '../store/ChangeDetected';
import { clearChanges as clearAdvancedChanges } from '../store/ChangeAdvanceDetected';
import {setIsChangeBan} from "../store/ChangeBan";

export const useBan = () => {
  const dispatch = useDispatch();
  const { changesDetected } = useSelector((state) => state.changeDetected);
  const { changesAdvanceDetected } = useSelector((state) => state.changeAdvanceDetected);
  
  const clearAllChanges = () => {
    dispatch(clearChanges());
    dispatch(clearAdvancedChanges());
    dispatch(setIsChangeBan(false));
  }

  const setIsBan = (isBan) => {
    dispatch(setIsChangeBan(isBan));
  }

return {isBan: changesDetected || changesAdvanceDetected, clearAllChanges, setIsBan}
}